import React, { useState } from "react";
import {
  Button,
  Container,
  Row,
  Col,
} from "reactstrap";
import DonationTracking from "./DonationTracking";
import MonthlyAccounts from "./MonthlyAccount";
import TeacherSalary from "./TeacherSalary";
import Footer from "components/Footers/Footer";

const FinanceManagement = () => {
  const [activeTab, setActiveTab] = useState("monthly-accounts");

  return (
    <>
      <div
        className="header   d-flex align-items-center"
        style={{
          minHeight: "600px",
          backgroundImage:
            "url(" + require("../../assets/img/theme/alRehman.jpg") + ")",
          backgroundSize: "cover",
          backgroundPosition: "center top",
        }}
      >
        {/* Mask */}
        <span className="mask bg-gradient-default opacity-8" />
        {/* Header container */}
        <Container className="d-flex align-items-center" fluid>
          <Row>
            <Col lg="7" md="10">
              <h1 className="display-2 text-white">Finance Management</h1>
              <p className="text-white mt-0 mb-5">
                Here you can view and manage the financial details of the
                organization. Review the information carefully and make any
                necessary updates or follow-ups.
              </p>
              <Button
                color={
                  activeTab === "monthly-accounts" ? "danger" : "secondary"
                }
                href="#pablo"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab("monthly-accounts");
                }}
              >
                Monthly Accounts
              </Button>
              <Button
                color={
                  activeTab === "donation-tracking" ? "warning" : "secondary"
                }
                href="#pablo"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab("donation-tracking");
                }}
              >
                Donation Tracking
              </Button>
              <Button
                color={activeTab === "payroll" ? "info" : "secondary"}
                href="#pablo"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab("payroll");
                }}
              >
                Payroll
              </Button>

            </Col>
          </Row>
        </Container>
      </div>
      {/* Page content */}
      <Container className="mt--7" fluid>
        {activeTab === "monthly-accounts" && <MonthlyAccounts />}
        {activeTab === "donation-tracking" && <DonationTracking />}
        {activeTab === "payroll" && <TeacherSalary />}
        <Footer />

      </Container>
    </>
  );
};

export default FinanceManagement;